export default function Logo() {
  return (
    <div className="flex items-center space-x-2">
      <div className="w-8 h-8 bg-blue-600 dark:bg-blue-500 rounded-lg flex items-center justify-center">
        <span className="text-white font-bold text-lg">L</span>
      </div>
      <span className="text-xl font-bold text-gray-900 dark:text-gray-100">Lamyda</span>
    </div>
  )
}
